export class Tooltip {
	constructor() {
		this.trigger = null
		this.pinned = false
		this.timer = null
		this.focusFrame = null
		this.element = document.createElement('div')
		this.element.id = 'school-tooltip'
		this.element.className = 'tooltip'
		this.element.setAttribute('role', 'tooltip')
		this.element.hidden = true

		document.addEventListener('pointerover', (e) => {
			if (e.pointerType !== 'mouse') return
			if (this.element.contains(e.target)) {
				window.clearTimeout(this.timer)
				return
			}
			const trigger = e.target.closest('[data-tooltip]')
			if (trigger && !trigger.contains(e.relatedTarget)) this.show(trigger)
		})
		document.addEventListener('pointerout', (e) => {
			if (!this.trigger || this.pinned) return
			if (!this.trigger.contains(e.target) && !this.element.contains(e.target)) return
			if (this.trigger.contains(e.relatedTarget) || this.element.contains(e.relatedTarget)) return
			this.timer = window.setTimeout(() => this.hide(), 120)
		})
		document.addEventListener('focusin', (e) => {
			const trigger = e.target.closest('[data-tooltip]')
			if (!trigger || !trigger.matches(':focus-visible')) return
			// Измеряем положение после начала прокрутки, вызванной фокусом
			this.focusFrame = window.requestAnimationFrame(() => {
				this.focusFrame = null
				if (document.activeElement === trigger) this.show(trigger)
			})
		})
		document.addEventListener('focusout', (e) => {
			window.cancelAnimationFrame(this.focusFrame)
			this.focusFrame = null
			if (this.trigger && this.trigger.contains(e.target)) this.hide()
		})
		document.addEventListener('click', (e) => {
			const trigger = e.target.closest('[data-tooltip]')
			if (!trigger) return
			e.preventDefault()
			if (this.trigger === trigger && this.pinned) this.hide()
			else {
				this.show(trigger)
				this.pinned = true
			}
		})
		document.addEventListener('pointerdown', (e) => {
			if (this.trigger && !this.trigger.contains(e.target) && !this.element.contains(e.target)) this.hide()
		})
		window.addEventListener('keydown', (e) => {
			if (e.key !== 'Escape' || (!this.trigger && !this.focusFrame)) return
			e.preventDefault()
			e.stopImmediatePropagation()
			window.cancelAnimationFrame(this.focusFrame)
			this.focusFrame = null
			this.hide()
		}, true)
		// Подсказка не остаётся висеть над другой карточкой при прокрутке таблицы или попапа
		window.addEventListener('scroll', (e) => {
			if (this.element.contains(e.target)) return
			// Переход табом может запускать плавную прокрутку уже после события focusin
			if (this.trigger && this.trigger === document.activeElement && !this.pinned && this.trigger.matches(':focus-visible')) this.position()
			else this.hide()
		}, true)
		window.addEventListener('resize', () => this.hide())
		document.addEventListener('popup:open', () => this.hide())
		document.addEventListener('popup:close', () => this.hide())
		if (window.visualViewport) {
			window.visualViewport.addEventListener('resize', () => this.hide())
			window.visualViewport.addEventListener('scroll', () => this.hide())
		}
	}

	show(trigger) {
		window.clearTimeout(this.timer)
		if (this.trigger !== trigger) this.hide()
		this.trigger = trigger
		const describedBy = (trigger.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean)
		if (!describedBy.includes(this.element.id)) describedBy.push(this.element.id)
		trigger.setAttribute('aria-describedby', describedBy.join(' '))
		trigger.setAttribute('aria-expanded', 'true')
		this.element.textContent = trigger.dataset.tooltip
		// Внутри dialog подсказка тоже должна находиться в верхнем слое, вне скролла карточки
		const parent = trigger.closest('dialog') || document.body
		parent.appendChild(this.element)
		this.position()
	}

	position() {
		const viewport = window.visualViewport
		const width = viewport ? viewport.width : document.documentElement.clientWidth
		const height = viewport ? viewport.height : window.innerHeight
		const left = viewport ? viewport.offsetLeft : 0
		const top = viewport ? viewport.offsetTop : 0
		this.element.style.maxWidth = `${Math.min(320, Math.max(0, width - 32))}px`
		this.element.style.maxHeight = `${Math.max(0, height - 32)}px`
		this.element.style.left = `${left + 16}px`
		this.element.style.top = `${top + 16}px`
		this.element.hidden = false
		const anchor = this.trigger.getBoundingClientRect()
		const box = this.element.getBoundingClientRect()
		const below = anchor.bottom + 8
		const y = below + box.height <= top + height - 16 ? below : anchor.top - box.height - 8
		this.element.style.left = `${Math.max(left + 16, Math.min(anchor.left, left + width - box.width - 16))}px`
		this.element.style.top = `${Math.max(top + 16, Math.min(y, top + height - box.height - 16))}px`
		this.element.hidden = anchor.bottom <= top || anchor.top >= top + height || anchor.right <= left || anchor.left >= left + width
	}

	hide() {
		window.clearTimeout(this.timer)
		if (this.trigger) {
			const describedBy = (this.trigger.getAttribute('aria-describedby') || '').split(/\s+/).filter((id) => id && id !== this.element.id)
			if (describedBy.length) this.trigger.setAttribute('aria-describedby', describedBy.join(' '))
			else this.trigger.removeAttribute('aria-describedby')
			this.trigger.setAttribute('aria-expanded', 'false')
		}
		this.element.hidden = true
		this.trigger = null
		this.pinned = false
	}
}
